import { MTServiceMasterTable } from './MTServiceMasterTable'

/**
 * MTServiceMasterPage - Renders the Service Master table component.
 */
export function MTServiceMasterPage() {
  return <MTServiceMasterTable />
}